import { defineMessage } from 'services/localization';

export const messages = {
    title: defineMessage('fraud_detection_changes_after_approval'),
    subtitle: defineMessage('what_changes_made_in_ci__company_administrators'),
    optionSupplier: defineMessage('supplier'),
    optionAmount: defineMessage('total_amount_more_than_companycurrencycode_change'),
    optionDate: defineMessage('date'),
    optionLocation: defineMessage('location'),
    optionMemo: defineMessage('memo'),
    optionItemLine: defineMessage('item_line'),
    optionAdditionalChargeLine: defineMessage('category'),
};
